(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search-filter"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    var header = document.querySelector('.cf-filter-header');

    // Filter dropdown toggle
    var toggle = e.target.closest('.cf-filter-toggle');
    if (toggle) {
      e.preventDefault();
      if (!header) return;
      var isOpen = header.classList.toggle('is-open');
      toggle.classList.toggle('is-open', isOpen);
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      return;
    }

    // Click outside – close filter dropdown
    if (header && !e.target.closest('.cf-filter-header')) {
      header.classList.remove('is-open');
      var btn = header.querySelector('.cf-filter-toggle');
      if (btn) {
        btn.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      }
    }

    // Sort arrow button
    var arrowBtn = e.target.closest('.cf-sort-arrow-btn');
    if (arrowBtn) {
      e.preventDefault();
      var sortSelect = document.getElementById('cf-filter-by-sort-by');
      if (sortSelect) {
        sortSelect.focus();
        try { sortSelect.click(); } catch (err) {}
      }
    }
  });

  // Auto-submit when a cf-filter-select changes (AJAX)
  document.addEventListener('change', function (e) {
    var select = e.target.closest('.cf-filter-select');
    if (!select) return;

    var form = select.closest('form');
    if (!form) return;

    var url = new URL(window.location.href);
    var params = url.searchParams;
    var formData = new FormData(form);

    formData.forEach(function (value, key) {
      params.set(key, value);
    });

    var newUrl = form.action ? new URL(form.action, window.location.origin) : url;
    newUrl.search = params.toString();

    fetch(newUrl.toString(), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(function (response) { return response.text(); })
    .then(function (html) {
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;

      var newContainer = tempDiv.querySelector('[data-ajax-container][data-ajax-scroll-to]');
      var curContainer = document.querySelector('[data-ajax-container][data-ajax-scroll-to]');
      if (newContainer && curContainer) {
        curContainer.innerHTML = newContainer.innerHTML;
      }
    })
    .catch(function (err) {
      console.error('Filter fetch error', err);
    });
  });

  document.addEventListener('ajax:filters-updated', function () {
    if (window.Currency && typeof window.Currency.convertAll === 'function') {
      window.Currency.convertAll();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
